<div *ngIf="isAvailable" class="relative">
  <button
    mat-icon-button
    type="button"
    (click)="togglePanel()"
    [matTooltip]="getTooltip()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
  >
    <mat-icon>{{ impersonation ? 'manage_accounts' : 'storage' }}</mat-icon>
  </button>
  <span
    class="absolute -bottom-1 left-1/2 -translate-x-1/2 text-[9px] font-bold px-1 rounded text-white whitespace-nowrap"
    [style.background-color]="getBadgeColor()"
  >
    {{ getBadgeLabel() }}
  </span>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isPanelOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    (backdropClick)="closePanel()"
    [cdkConnectedOverlayPositions]="overlayPositions"
  >
    <app-dev-tools-panel [status]="status" (closed)="closePanel()" (statusChanged)="ngOnInit()"></app-dev-tools-panel>
  </ng-template>
</div>
